import resources from 'app/translations/resources';
import { isEdelvives } from './utils';
// import edelvivesResources from 'edelvives/translations/resources';

export function importLanguageResources(tenant, defaultLanguage) {
  // En allLanguages tenemos todas las claves del archivo resources, que contiene los idiomas origen y los específicos de cada cliente
  // ej ['es', 'en', 'es_MACMILLAN', 'en_GOTITBYME'....]
  const allLanguages = Object.keys(resources);
  // En availableLanguages vamos a obtener todos los idiomas que pueden existir en la app
  const availableLanguages = getAvailableLanguages();
  let languageKeys = {};
  const tenantName = tenant?.name;

  availableLanguages.forEach((lang) => {
    // Si en allLanguages tenemos el idioma específico del tenant, lo añadimos, si no, añadimos el idioma origen
    if (isEdelvives()) {
      languageKeys[lang] = resources[lang + '_Edelvives Digital Plus'];
    } else if (allLanguages.includes(lang + '_' + tenantName)) {
      languageKeys[lang] = resources[lang + '_' + tenantName];
    } else if (defaultLanguage !== 'es' && allLanguages.includes(defaultLanguage)) {
      languageKeys[lang] = resources[defaultLanguage];
    } else {
      languageKeys[lang] = resources[lang];
    }
  });

  return languageKeys;
}

function getAvailableLanguages() {
  return [...new Set(Object.keys(resources).map((lang) => lang.split('_')[0]))];
}
